<template>
  <div
    class="drawer__list-item group"
    :class="{ 'is-loading': isLoading }"
    :key="label.id"
    :style="'--label-color:' + label.color"
  >
    <div class="flex items-center gap-3 w-full">
      <!-- Drag Handle -->
      <span class="handle cursor-move text-neutral-400 hover:text-neutral-600 transition-colors">
        <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 8h16M4 16h16"></path>
        </svg>
      </span>

      <!-- Color Dot -->
      <span class="w-3 h-3 rounded-full flex-shrink-0" :style="{ backgroundColor: label.color }"></span>

      <!-- Name -->
      <span class="flex-1 text-sm font-medium text-neutral-700 truncate">
        {{ label.name }}
      </span>

      <!-- Visibility Toggle -->
      <button
        type="button"
        class="visibility-toggle"
        :class="{ 'is-hidden': hideRoadmap }"
        @click.prevent="toggleVisibility()"
        :title="hideRoadmap ? $t('Hidden from roadmap') : $t('Visible on roadmap')"
      >
        <!-- Visible Icon -->
        <svg v-if="!hideRoadmap" class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"></path>
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z"></path>
        </svg>
        <!-- Hidden Icon -->
        <svg v-else class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13.875 18.825A10.05 10.05 0 0112 19c-4.478 0-8.268-2.943-9.543-7a9.97 9.97 0 011.563-3.029m5.858.908a3 3 0 114.243 4.243M9.878 9.878l4.242 4.242M9.88 9.88l-3.29-3.29m7.532 7.532l3.29 3.29M3 3l3.59 3.59m0 0A9.953 9.953 0 0112 5c4.478 0 8.268 2.943 9.543 7a10.025 10.025 0 01-4.132 5.411m0 0L21 21"></path>
        </svg>
        <span class="text-xs font-medium ml-1.5">
          {{ hideRoadmap ? $t('Hidden') : $t('Visible') }}
        </span>
      </button>
    </div>
  </div>
</template>

<script>
export default {
  props: ["original-label", "project-id"],

  data: function() {
    return {
      label: this.originalLabel,
      hideRoadmap: this.originalLabel.hide_roadmap,
      isLoading: false
    };
  },

  methods: {
    toggleVisibility() {
      this.isLoading = true;
      this.hideRoadmap = !this.hideRoadmap;

      let params = new FormData();
      params.append("label[hide_roadmap]", this.hideRoadmap);

      Rails.ajax({
        url: "/statuses/" + this.label.id,
        type: "PATCH",
        data: params,
        dataType: "json",
        beforeSend: function() {
          return true;
        },
        success: data => {
          this.$emit("updatedStatusRoadmap", data);
          this.isLoading = false;
        },
        error: (data, status) => {
          console.log(data);
          // Revert on error
          this.hideRoadmap = !this.hideRoadmap;
          this.isLoading = false;
        }
      });
    }
  }
};
</script>

<style scoped>
.visibility-toggle {
  display: inline-flex;
  align-items: center;
  padding: 0.375rem 0.625rem;
  background: theme('colors.neutral.100');
  border: 1px solid theme('colors.neutral.200');
  border-radius: 0.375rem;
  color: theme('colors.neutral.600');
  font-size: 0.75rem;
  cursor: pointer;
  transition: all 150ms ease;
}

.visibility-toggle:hover {
  background: theme('colors.neutral.200');
  border-color: theme('colors.neutral.300');
}

.visibility-toggle.is-hidden {
  background: theme('colors.neutral.50');
  border-color: theme('colors.neutral.200');
  color: theme('colors.neutral.400');
}

.visibility-toggle.is-hidden:hover {
  background: theme('colors.neutral.100');
  color: theme('colors.neutral.500');
}
</style>
